import {Root} from "./store-root";
import {action, computed, observable, runInAction} from "mobx";
import {Auth} from "aws-amplify";
import {CognitoUser} from "amazon-cognito-identity-js";
import {LoginRequest} from "../models/signin/login-request";
import {CompleteNewPasswordFormValues} from "../models/signin/form-values-complete-new-password";
import {history} from "../..";
import {ForgotPasswordRequest} from "../models/signin/ForgotPasswordRequest";
import {ForgotPasswordSubmitRequest} from "../models/signin/ForgotPasswordSubmitRequest";

export class UserStore {
    parent: Root;
    //@observable user:UserProfile|undefined = undefined;
    @observable user: CognitoUser | undefined = undefined;
    @observable notAuthorized: boolean = false;
    @observable Address: string = '';
    @observable AllowedExchanges: string[] = [];
    @observable Branch: string = '';
    @observable Country: string = '';
    @observable Role: string = '';
    @observable Email: string = '';

    @observable FamilyName: string = '';
    @observable Name: string = '';
    @observable Phone: string = '';
    @observable Sub: string = '';
    @observable UserName: string = '';
    @observable BalanceLimit: number = 0;

    @observable CurrencyCode: string = '';
    @observable CurrencyLabel: string = '';
    @observable CurrencySymbol: string = '';
    @observable CountryCode: string = '';


    constructor(root: Root) {
        this.parent = root;
    }


    @action login = async (request: LoginRequest) => {
        try {
            console.log('Login Request ', request)
            const user: CognitoUser = await Auth.signIn(
                request.username,
                request.password
            );
            runInAction(() => {
                this.user = user;
            });
            return user;
            /*const data = await API.get('Data','/data',{headers:{'Auth':user.signInUserSession.idToken.jwtToken}});
                  console.log(data);*/
            //await Auth.forgotPassword('mokhal');
        } catch (error) {
            //Todo : handle NewPasswordRequired
            //Todo: handle Account suspended
            //Todo : handle Not authenticated or invalid username\password
            console.log(error);
            throw error;
        }
    };

    @action forgotPassword = async (request: ForgotPasswordRequest) => {
        try {
            const returned = await Auth.forgotPassword(request.username);
            console.log("Forgot Password returned ",JSON.stringify(returned));
        } catch (error) {
            console.log('Error while processing forgotpassword request ',error);
            throw error;
        }
    }

    @action forgotPasswordSubmit = async (request: ForgotPasswordSubmitRequest) => {
        try {
            const returned = await Auth.forgotPasswordSubmit(request.username,request.code,request.newPassword);
            console.log("Forgot Password Submit returned ",JSON.stringify(returned));
        } catch (error) {
            console.log('Error while processing forgotpassword request ',error);
            throw error;
        }
    }


    @action getCurrentUser = async () => {
        Auth.currentAuthenticatedUser()
            .then((user: any) => {
                console.log("User avialble: ", user.attributes);
                this.user = user;
                this.Address = user.attributes['address'];
                this.AllowedExchanges = JSON.parse(user.attributes['custom:allowed_exchanges']);
                this.BalanceLimit = parseFloat(user.attributes['custom:balance_limit']);
                this.Country = user.attributes['custom:country'];
                this.Role = user.attributes['custom:role'];
                this.Email = user.attributes['email'];
                this.FamilyName = user.attributes['family_name'];
                this.Name = user.attributes['name'];
                this.Phone = user.attributes['phone_number'];
                this.Sub = user.attributes['sub'];
                this.UserName = user.getUsername();
                this.CurrencyCode = user.attributes['custom:currency_code'];
                this.CurrencyLabel = user.attributes['custom:currency_label'];
                this.CurrencySymbol = user.attributes['custom:currency_symbol'];
                this.CountryCode = user.attributes['custom:country_code'];

            })
            .catch((error) => {
                console.log("No user : ", error);
                history.push("/signin");
            });

        // const currentUserInfo = await Auth.currentUserInfo();
        // runInAction(() => {
        //   this.userInfo = currentUserInfo;
        // });
    };

    @computed get isAdmin() {
        return this.Role === 'BUSINESS_ADMIN';
    }

    @computed get isSendingAgent() {
        return this.Role === 'SEND_AGENT';
    }

    @computed get isReceiveAgent() {
        return this.Role === 'RECEIVE_AGENT';
    }

    @computed get isCashier() {
        return this.Role === 'RECEIVE_AGENT_CASHIER';
    }

    @computed get isSupervisor() {
        return this.Role === 'RECEIVE_AGENT_SUPERVISOR';
    }

    @action signOut = () => {
        Auth.signOut().then(() => {
            this.user = undefined;
            history.push("/signin");
        });
    };

    @action completeNewPassword(request: CompleteNewPasswordFormValues) {
        try {
            Auth.signIn(request.email, request.currentPassword).then((user: any) => {
                if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
                    const {requiredAttributes} = user.challengeParam;
                    Auth.completeNewPassword(
                        user, // the Cognito User Object
                        request.new, // the new password
                        requiredAttributes
                    )
                        .then((user) => {
                            // at this time the user is logged in if no MFA required
                            console.log(user);
                            history.push("/");
                        })
                        .catch((e) => {
                            console.log(e);
                        });
                } else {
                    // other situations
                }
            });
        } catch (e) {
            console.log(e);
        }
    }
}
